import { render, staticRenderFns } from "./blacklist.vue?vue&type=template&id=542d2a0e&scoped=true"
import script from "./blacklist.vue?vue&type=script&lang=js"
export * from "./blacklist.vue?vue&type=script&lang=js"
import style0 from "./blacklist.vue?vue&type=style&index=0&id=542d2a0e&prod&lang=less"
import style1 from "./blacklist.vue?vue&type=style&index=1&id=542d2a0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542d2a0e",
  null
  
)

export default component.exports